import React, { useEffect, useState } from 'react';
import { Menu, X, Moon, Sun, Shield } from 'lucide-react';
interface NavbarProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}
export function Navbar({
  currentPage,
  onNavigate
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    // Check for saved dark mode preference
    const savedMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedMode);
    if (savedMode) {
      document.documentElement.classList.add('dark');
    }
  }, []);
  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem('darkMode', String(newMode));
    if (newMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };
  const navItems = [{
    id: 'home',
    label: 'Start'
  }, {
    id: 'rechner',
    label: 'Rechner'
  }, {
    id: 'blog',
    label: 'Blog'
  }, {
    id: 'app',
    label: 'Kunden-App'
  }, {
    id: 'beratung',
    label: 'Beratung'
  }];
  const handleNavClick = (pageId: string) => {
    onNavigate(pageId);
    setIsOpen(false);
  };
  return <nav className="fixed z-50 w-full px-2 top-0 pt-2" data-id="element-242">
      <div className={`mx-auto max-w-6xl px-6 transition-all duration-300 lg:px-12 ${scrolled ? 'bg-background/50 max-w-4xl rounded-2xl border backdrop-blur-lg lg:px-5 shadow-sm' : ''}`} data-id="element-243">
        <div className="relative flex flex-wrap items-center justify-between gap-6 py-3 lg:gap-0 lg:py-4" data-id="element-244">
          {/* Logo */}
          <div className="flex w-full justify-between lg:w-auto" data-id="element-245">
            <div className="flex items-center gap-2.5 cursor-pointer group" onClick={() => handleNavClick('home')} data-id="element-246">
              <div className="flex items-center justify-center h-9 w-9 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 text-white shadow-md shadow-blue-500/20 group-hover:shadow-blue-500/40 transition-all" data-id="element-247">
                <Shield className="h-5 w-5" data-id="element-248" />
              </div>
              <div className="flex flex-col" data-id="element-249">
                <span className="text-sm font-semibold text-foreground leading-tight" data-id="element-250">
                  smartprotect24
                </span>
              </div>
            </div>

            {/* Mobile Menu Toggle */}
            <div className="flex items-center gap-2 lg:hidden" data-id="element-251">
              <button onClick={toggleDarkMode} className="p-2 text-muted-foreground hover:text-foreground transition-colors" aria-label="Toggle dark mode" data-id="element-252">
                {darkMode ? <Sun className="h-5 w-5" data-id="element-253" /> : <Moon className="h-5 w-5" data-id="element-254" />}
              </button>
              <button onClick={() => setIsOpen(!isOpen)} className="relative z-20 -m-2.5 block cursor-pointer p-2.5" data-id="element-255">
                {isOpen ? <X className="h-5 w-5" data-id="element-256" /> : <Menu className="h-5 w-5" data-id="element-257" />}
              </button>
            </div>
          </div>

          {/* Desktop Navigation - Centered */}
          <div className="absolute inset-0 m-auto hidden size-fit lg:block" data-id="element-258">
            <ul className="flex gap-8 text-sm font-medium" data-id="element-259">
              {navItems.map(item => <li key={item.id} data-id="element-260">
                  <button onClick={() => handleNavClick(item.id)} className={`transition-colors duration-150 ${currentPage === item.id ? 'text-blue-600 dark:text-blue-400 font-semibold' : 'text-muted-foreground hover:text-blue-600 dark:hover:text-blue-400'}`} data-id="element-261">
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Desktop Right Side (Dark Mode) */}
          <div className="hidden lg:flex items-center justify-end" data-id="element-262">
            <button onClick={toggleDarkMode} className="p-2 text-muted-foreground hover:text-foreground transition-colors rounded-full hover:bg-muted" aria-label="Toggle dark mode" data-id="element-263">
              {darkMode ? <Sun className="h-5 w-5" data-id="element-264" /> : <Moon className="h-5 w-5" data-id="element-265" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isOpen && <div className="lg:hidden absolute top-full left-0 w-full px-2 mt-2" data-id="element-266">
          <div className="bg-background/95 backdrop-blur-md rounded-2xl border shadow-lg p-4 mx-auto max-w-6xl" data-id="element-267">
            <ul className="space-y-4 text-base" data-id="element-268">
              {navItems.map(item => <li key={item.id} data-id="element-269">
                  <button onClick={() => handleNavClick(item.id)} className={`block w-full text-left ${currentPage === item.id ? 'text-blue-600 dark:text-blue-400 font-semibold' : 'text-muted-foreground hover:text-blue-600 dark:hover:text-blue-400'}`} data-id="element-270">
                    {item.label}
                  </button>
                </li>)}
            </ul>
          </div>
        </div>}
    </nav>;
}